import { Observable, BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Config } from '../config';
import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { HttpClient } from '@angular/common/http';
import { PaginatedResponse } from '../models/paginated-response.model';
import { NotificationsModel, NotificationsCountModel } from '../models/notifications.model';

@Injectable()
export class NotificationService extends HttpService {
    private _count$ = new BehaviorSubject<number>(0);
 
    constructor(
        http: HttpClient,
    ) {
        super(http);
    }

    getNotifications(params?: any): Observable<PaginatedResponse<NotificationsModel>> {
        return this.http.get<PaginatedResponse<NotificationsModel>>(`${Config.apiUrl}/notification`, {
            params: this.serialize(params)
        });
    }

    markAllAsRead() {
        return this.http.post(this.buildUrl('notification/mark-all-as-read'), {});
    }

    getNotificationCounter() {
        return this.http.get<NotificationsCountModel>(this.buildUrl('notification/unread/count'));
    }

    markAsRead(id) {
        return this.http.post(this.buildUrl(`notification/mark-as-read/${id}`), {});
    }

    destroyNotification(id) {
        return this.http.post(this.buildUrl('notification/destroy'), {
            id
        });
    }
    get count$(): Observable<number> {
        return this._count$.asObservable();
    }
     /** New method to refresh and update global counter */
    refreshCount(): void {
        this.http.get<NotificationsCountModel>(`${Config.apiUrl}/notification/unread/count`)
            .subscribe({
                next: (res) => this._count$.next(res.notifications_count),
                error: (err) => console.error('Failed to fetch notification count', err)
            }
        );
    }

    /** Optional: get current value without subscribing */
    getCurrentCount(): number {
        return this._count$.value;
    }

}
